<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   [showCreate]="accountPrivileges?.canAdd"
   [searchText]="searchText"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   [moreActionsMenu]="accountRegisterActionMenu"
>
   <ndt-register-quick-filter class="inactive-accounts-toggle">
      <mat-form-field class="lcs-internal-select">
         <mat-label>Filter by LCS Internal</mat-label>
         <input
            [lcsSingleSelect]="isLcsInternalSelect"
            [(ngModel)]="selectedInternalOption"
            lcsStaticSelect
            [lcsStaticSelectValue]="selectedInternalOption"
            autocomplete="off"
            type="text"
            placeholder="All Accounts"
            id="isLcsInternal"
            (ngModelChange)="internalOptionsChange($event)"
         />
         <lcs-static-select #isLcsInternalSelect>
            @for (internalOption of isLcsInternalOptions; track internalOption) {
            <lcs-option [value]="internalOption">
               {{ internalOption }}
            </lcs-option>
            }</lcs-static-select
         >
      </mat-form-field>
      @if (showAllAccountsControl) {
      <mat-slide-toggle
         class="slide-toggle"
         id="toggle-show-all-accounts"
         color="primary"
         [ngModel]="includeInactive"
         (ngModelChange)="showAllAccountsChange($event)"
      >
         Include Inactive
      </mat-slide-toggle>
      }
      <mat-slide-toggle
         class="slide-toggle"
         id="toggle-search-by-log-level"
         color="primary"
         [ngModel]="showElevatedLogLevel"
         (ngModelChange)="searchByLogLevelChange($event)"
      >
         Show Accounts with Elevated Log Levels
      </mat-slide-toggle>
   </ndt-register-quick-filter>

   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="name" width="4">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="name-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="name"
               >Name
               <mat-icon class="mat-icon-sort">{{ getSort('name') }}</mat-icon>
            </th>

            <td lcs-cell *lcsCellDef="let account">
               <a [routerLink]="getRouterLink(account.accountId)">
                  {{ account.name }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="shortName" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="short-name-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="shortName"
               >Company Code<mat-icon class="mat-icon-sort">{{ getSort('shortName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let account">
               <a [routerLink]="getRouterLink(account.accountId)">
                  {{ account.shortName }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="isActive" width="1">
            <th lcs-header-cell *lcsHeaderCellDef id="active-column-header">Active</th>
            <td lcs-cell *lcsCellDef="let account">
               <a [routerLink]="getRouterLink(account.accountId)">
                  @if (account.isActive) {
                  <mat-icon>check</mat-icon>
                  }
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="lcsAccountNumber" width="2.5">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="lcs-account-number-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="lcsAccountNumber"
               >LCS Account Number<mat-icon class="mat-icon-sort">{{ getSort('lcsAccountNumber') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let account">
               <a [routerLink]="getRouterLink(account.accountId)">
                  {{ account.lcsAccountNumber }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="pstnLineLimit" width="1">
            <th
               class="register-column-header numeric"
               lcs-header-cell
               *lcsHeaderCellDef
               id="pstn-line-limit-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="pstnLineLimit"
               >Lines<mat-icon class="mat-icon-sort">{{ getSort('pstnLineLimit') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let account" class="numeric">
               <a [routerLink]="getRouterLink(account.accountId)">
                  {{ account.pstnLineLimit }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="extensionCount" width="1.5">
            <th
               class="register-column-header numeric"
               lcs-header-cell
               *lcsHeaderCellDef
               id="extension-count-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="extensionCount"
               >Extensions <mat-icon class="mat-icon-sort">{{ getSort('extensionCount') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let account" class="numeric">
               <a [routerLink]="getRouterLink(account.accountId)">
                  {{ account.extensionCount }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="phoneNumberCount" width="1.75">
            <th
               class="register-column-header numeric"
               lcs-header-cell
               *lcsHeaderCellDef
               id="phone-number-count-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="phoneNumberCount"
               >Phone Numbers <mat-icon class="mat-icon-sort">{{ getSort('phoneNumberCount') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let account" class="numeric">
               <a [routerLink]="getRouterLink(account.accountId)">
                  {{ account.phoneNumberCount }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="logLevelId" width="1.25">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="log-level-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="logLevelId"
               >Log Level<mat-icon class="mat-icon-sort">{{ getSort('logLevelId') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let account">
               <a [routerLink]="getRouterLink(account.accountId)">
                  {{ account.logLevelId }}
               </a>
            </td></ng-container
         >
         <ng-container lcsColumnDef="accountActionsMenu" width="0.5">
            <th lcs-header-cell *lcsHeaderCellDef id="account-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let account">
               <button
                  type="button"
                  aria-label="Account Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="accountsMenu"
                  id="account-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               <mat-menu #accountsMenu="matMenu">
                  <a mat-menu-item [routerLink]="getRouterLink(account.accountId)"> Details </a>
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
<mat-menu #accountRegisterActionMenu="matMenu">
   <ng-template matMenuContent>
      <button type="button" mat-menu-item id="account-register-reset-mwi-button" (click)="onResetMwiClick()">
         Reset MWI
      </button>
   </ng-template>
</mat-menu>
